import { Component, OnDestroy, OnInit, Pipe } from '@angular/core';
import { ProjectServicesService } from '../shared/services/project-services.service';
import { SharedService } from '../shared/services/shared.service';
import {
  faAngleLeft,
  faAngleRight,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faFileExport,
  faInfoCircle,
  faProjectDiagram,
  faStepBackward,
  faStepForward,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
import { AppService } from '../shared/services/app.service';
import { MainComponent } from '../main/main.component';
import { InteractionMapperComponent } from '../interaction-mapper/interaction-mapper.component';
import { PagerService } from '../shared/services/pager.service';
import { SocketService } from '../shared/services/socket.service';
import { Subscription } from 'rxjs';
import { ReloadToolService } from '../shared/services/reload-tool.service';
declare var $: any;

@Component({
  selector: 'app-persona-mapper',
  templateUrl: './persona-mapper.component.html',
  styleUrls: ['./persona-mapper.component.scss'],
})
export class PersonaMapperComponent implements OnInit, OnDestroy {
  private allItems: any = [];
  pager: any = {};
  pagedItems: any = [];
  clickEventsubscriptionSocket: Subscription;
  proDataSubscription: Subscription = new Subscription();

  constructor(
    private ProjectServices: ProjectServicesService,
    private _sharedService: SharedService,
    private socketService: SocketService,
    private Config: Config,
    private appService: AppService,
    private reloadToolService: ReloadToolService,
    public mainComponent: MainComponent,
    public interactionMapperComponent: InteractionMapperComponent,
    private pagerService: PagerService
  ) {
    this.clickEventsubscriptionSocket = this.socketService
      .getClickEvent()
      .subscribe(() => {
        this.ngOnInit();
      });
  }
  /// icons
  faCircle = faCircle;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faStepForward = faStepForward;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;
  faStepBackward = faStepBackward;
  faFileExport = faFileExport;
  faProjectDiagram = faProjectDiagram;
  faUser = faUser;
  faInfoCircle = faInfoCircle;
  personaMapUI: any;
  deSelectCollection: any;
  // contentWindow:any;
  // model: any;
  eutCollection: any = { TF: [], UR: [], BF: [] };
  personas: any;
  personaMap: any;
  listOfEUTs: any;
  selectedEUT: any;

  EUTtypes: any = ['TF', 'UR', 'BF'];
  modelData: any;
  disableDown: any;
  disableUp: any;
  filterTypeCount: any = { type: 'count' };

  /// model data

  model: any = {
    startAt: 0,
    eutType: 'TF',
    maxColumns: 15,
    maxRows: 10,
    listLength: 10,
    persona: {},
    pMap: {},
    eutCollection: {},
    personaMap: { TF: [], UR: [], BF: [] },
    personaMapUI: { TF: [], UR: [], BF: [] },
    personaMapIndex: { TF: [], UR: [], BF: [] },
    deSelectCollection: this.Config.UIstates.personaMapper,
  };

  //variable to keep track of starting index of map and list
  // entityModel = entityModel;

  ///model close
  ngOnInit(): void {
    setTimeout(() => {
      this.getVideoURL('Pm')
    }, 2000);
    // this.modelData = this._sharedService.loadedProjectData.model;
    this.proDataSubscription = this._sharedService.projectJsonSubject.subscribe(data => {
      this.modelData = data.model;
    });
    this.listOfEUTs = this.modelData.listOfEUTs;
    this.personas = this.modelData.persona;
    this.personaMap = this.modelData.personaMap;

    this.eutCollection['TF'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'TF'
    );
    this.eutCollection['UR'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'UR'
    );
    this.eutCollection['BF'] = this.listOfEUTs.filter(
      (anEut: any) => anEut.eType == 'BF'
    );
    this.selectedEUT = this.eutCollection.UR[0];

    this.model.persona = this.modelData.persona;
    this.model.pMap = this.modelData.personaMap;
    this.model.eutCollection = this.eutCollection;
    this.allItems = this.eutCollection['UR'];
    this.setPage(1);

    this.manageElementsXaxis('persona');
    this.manageElementsYaxis('persona');
    this.setEUTtypeChosen('UR');
    this.loadPersonaMap(
      this.model.persona,
      this.model.pMap,
      this.model.eutCollection
    );
    this.loadPersonaMapUI(this.model.eutCollection);
    this.isUpDownValid();
    // data required from entityModel in landscaper
    // console.log('lsModel', this.modelData);
    setInterval(() => {
      this.updateProjectData();
    }, 2000);
    this.reloadToolService.triggerSmartChecklist('');
  }

  ngOnDestroy() {
    this.proDataSubscription.unsubscribe();
  }
  //function to get modulename by moduleID
  getModuleName(eut: any) {
    if(eut.mID){
      var foundModule: any = this.modelData.modules.find(
        (mod: any) => mod.mID == eut.mID
      );
      return foundModule.mName;
    }
    
  }
  setPage(page: number) {
    // get pager object from service
    this.pager = this.pagerService.getPager(this.allItems.length, page);
    // get current page of items
    this.pagedItems = this.allItems.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

  updateProjectData() {
    this._sharedService.projectContent(this.modelData);
  }

  //load the persona map according to the shifted tab
  //set the eut type and reset the value of start
  setEUTtypeChosen(eutChosen: any) {
    this.model.eutType = eutChosen;
    this.model.startAt = 0;
    this.loadPersonaMap(
      this.model.persona,
      this.model.pMap,
      this.eutCollection
    );
    this.loadPersonaMapUI(this.eutCollection);
    this.isUpDownValid();
  }
  //when select all is checked
  //empty my ids from delselected id list
  // and change the value of check in the eid list also
  toggleAllDeselect(checkVal: any) {
    var listEnd =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? this.model.startAt + this.model.listLength
        : this.eutCollection[this.model.eutType].length;

    for (var i = this.model.startAt; i < listEnd; i++) {
      if (checkVal) {
        var eID = this.model.deSelectCollection[this.model.eutType].findIndex(
          (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
        );
        this.model.deSelectCollection[this.model.eutType].splice(eID, 1);
      } else {
        var isPresent = this.model.deSelectCollection[
          this.model.eutType
        ].findIndex(
          (eutID: any) => eutID == this.eutCollection[this.model.eutType][i].eID
        );
        if (isPresent == -1) {
          this.model.deSelectCollection[this.model.eutType].push(
            this.eutCollection[this.model.eutType][i].eID
          );
        }
      }
    }
    this.loadPersonaMap(
      this.model.persona,
      this.model.pMap,
      this.eutCollection
    );
    this.loadPersonaMapUI(this.eutCollection);
  }

  toggleSelection(eID: any) {
    //if value is true -> remove from deselect list
    //if value is false -> add to deselect list
    var isPresent = this.model.deSelectCollection[this.model.eutType].findIndex(
      (eutID: any) => eutID == eID
    );
    // Is currently selected
    if (isPresent > -1) {
      this.model.deSelectCollection[this.model.eutType].splice(isPresent, 1);
    }
    // Is newly selected
    else {
      this.model.deSelectCollection[this.model.eutType].push(eID);
    }
    this.loadPersonaMap(
      this.model.persona,
      this.model.pMap,
      this.eutCollection
    );
    this.loadPersonaMapUI(this.eutCollection);
  }

  nextPage() {
    //finding start of list
    var startPosition = this.model.startAt + this.model.listLength;

    //if length of list is greater such that there is a next page
    //set the start to the nextpage first element
    if (this.eutCollection[this.model.eutType].length > startPosition) {
      this.model.startAt = startPosition;
      this.loadPersonaMap(
        this.model.persona,
        this.model.pMap,
        this.eutCollection
      );
      this.loadPersonaMapUI(this.eutCollection);
    }
    this.isUpDownValid();
    // console.log('startAt', this.model.startAt);
    // console.log('listLength', this.model.listLength);
  }

  previousPage() {
    var startPosition = this.model.startAt - this.model.listLength;
    if (startPosition >= 0) {
      this.model.startAt = startPosition;
      this.loadPersonaMap(
        this.model.persona,
        this.model.pMap,
        this.eutCollection
      );
      this.loadPersonaMapUI(this.eutCollection);
    }
    this.isUpDownValid();
    // console.log('startAt', this.model.startAt);
    // console.log('listLength', this.model.listLength);
  }

  firstPage() {
    this.model.startAt = 0;
    this.loadPersonaMap(
      this.model.persona,
      this.model.pMap,
      this.eutCollection
    );
    this.loadPersonaMapUI(this.eutCollection);
    this.isUpDownValid();
    // console.log('startAt', this.model.startAt);
    // console.log('listLength', this.model.listLength);
  }

  lastPage() {
    this.model.startAt =
      this.eutCollection[this.model.eutType].length -
      (this.eutCollection[this.model.eutType].length % this.model.listLength);
    // this.model.listLength =
    //   this.eutCollection[this.model.eutType].length - this.model.startAt;

    this.loadPersonaMap(
      this.model.persona,
      this.model.pMap,
      this.eutCollection
    );
    this.loadPersonaMapUI(this.eutCollection);
    this.isUpDownValid();
    // console.log('startAt', this.model.startAt);
    // console.log('listLength', this.model.listLength);
  }

  isUpDownValid() {
    this.disableDown =
      this.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? true
        : false;
    this.disableUp = this.model.startAt - 1 >= 0 ? true : false;
  }

  isChecked(ID: any) {
    var eID = this.model.deSelectCollection[this.model.eutType].findIndex(
      (eutID: any) => eutID == ID
    );
    if (eID == -1) {
      return true;
    } else {
      return false;
    }
  }

  isAllSelected() {
    var controller = this;
    var count = 0;
    var listEnd =
      controller.eutCollection[this.model.eutType].length >
        this.model.startAt + this.model.listLength
        ? this.model.startAt + this.model.listLength
        : controller.eutCollection[this.model.eutType].length;

    for (var i = this.model.startAt; i < listEnd; i++) {
      var isPresent = this.model.deSelectCollection[
        this.model.eutType
      ].findIndex(
        (eutID: any) =>
          eutID == controller.eutCollection[this.model.eutType][i].eID
      );
      if (isPresent > -1) {
        count++;
      }
    }
    var noOfRows = listEnd - this.model.startAt;
    if (count == 0) {
      return true;
    } else if (count == noOfRows || count < noOfRows) {
      return false;
    } else {
      return false;
    }
  }
  entityExists(eType: any) {
    var entityPresent = this.entityExistsCheck(eType);
    return entityPresent;
  }

  entityExistsCheck(eType: any) {
    var entities = this.modelData.listOfEUTs.filter(
      (entity: any) => entity.eType == eType
    );
    if (entities.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  openSmartChecklist() {
    this.reloadToolService.triggerSmartChecklist('la');
  }

  checkEntityMap(eut: any, selected: any) {
    for (var i = 0; i < this.personaMap.length; i++) {
      if (
        this.personaMap[i].eID == eut.eID &&
        this.personaMap[i].pType == selected.pType
      ) {
        return true;
      }
    }
    return false;
  }
  manageElementsXaxis(type: any) {
    if (type == 'persona') {
      $('.xSelectPersona').show();
      $('.xSelectAttribute').hide();
      $('.xSelectEut').hide();
    }
  }

  manageElementsYaxis(type: any) {
    if (type == 'persona') {
      $('.ySelectPersona').hide();
      $('.ySelectAttribute').hide();
      $('.ySelectEut').show();
    }
  }

  generateReport(auto: any) {
    let lanscapeArray = ['PersonaMapper'];
    window.localStorage.setItem('exportedData', JSON.stringify(lanscapeArray));
    window.localStorage.setItem('Entities', JSON.stringify(['TF', 'UR', 'BF']));
    if (auto == 'true') {
      window.open('/exportReport', '_blank');
      window.localStorage.setItem('autoDownload', 'true');
    }
  }

  //// ctrl fn closed
  //// model fn open

  //Construct the persona map for each eut type and load the map collection
  //after constructing check the persona map and mark * if there is a mapping for the person with eut
  loadPersonaMap(persona: any, pMap: any, eutCollection: any) {
    var model = this;
    for (var key in eutCollection) {
      model.personaMap[key] = [];
      persona.forEach(function (person: any) {
        var eutList: any = [];
        eutCollection[key].forEach(function (eut: any) {
          var mapped = pMap.find(function (amap: any) {
            return person.pType == amap.pType && eut.eID == amap.eID;
          });
          if (mapped) {
            eutList.push({ eID: eut.eID, map: '*' });
          } else if (!mapped) {
            eutList.push({ eID: eut.eID, map: '' });
          }
        });
        model.personaMap[key].push({ name: person, eutList });
      });
    }
  }

  loadPersonaMapUI(eutCollection: any) {
    for (var key in eutCollection) {
      //cloning the persona map to persona map ui
      this.model.personaMapUI[key] = $.extend(true, [], this.personaMap[key]);

      //for every persona
      //start from the list index in personamapUI
      //check whether eid in eut is in the deselected list and splice it
      //loop till max columns

      /// code commented temply

      this.model.personaMapUI[key].forEach((aPerson: any) => {
        for (i = aPerson.eutList.length - 1; i >= this.model.startAt; i -= 1) {
          var idExist = this.model.deSelectCollection[key].find(
            (id: any) => id == aPerson.eutList[i].eID
          );
          if (idExist) {
            aPerson.eutList.splice(i, 1);
          }
        }

        aPerson.eutList.splice(0, this.model.startAt);
        if (aPerson.eutList.length > this.model.maxColumns) {
          aPerson.eutList.splice(
            this.model.maxColumns,
            aPerson.eutList.length - this.model.maxColumns
          );
        }

        for (var i = aPerson.eutList.length; i < this.model.maxColumns; i++) {
          aPerson.eutList.push({ map: '-1' });
        }
      });

      //adding rows and columns to match the max rows and columns
      for (
        var i = this.model.personaMapUI[key].length;
        i < this.model.maxRows;
        i++
      ) {
        var eutList = [];
        for (var j = 0; j < this.model.maxColumns; j++) {
          eutList.push({ map: '-1' });
        }
        this.model.personaMapUI[key].push({ name: '', eutList });
      }
      //for the last row of index
      //check if eid exist in deselected list
      //if exist then skip it
      var eutList = [];

      for (var i = this.model.startAt; i < eutCollection[key].length; i++) {
        var idExist = this.model.deSelectCollection[key].find(
          (id: any) => id == eutCollection[key][i].eID
        );
        if (!idExist && eutList.length < this.model.maxColumns) {
          eutList.push({ map: i + 1 });
        }
      }
      for (var j = eutList.length; j < this.model.maxColumns; j++) {
        eutList.push({ map: '-1' });
      }
      this.model.personaMapIndex[key] = [];
      this.model.personaMapIndex[key].push({ name: '', eutList });
    }
  }

  // Handler to update the UI PeonalMap model & the actual PersonaMap model
  mapEUT(pChosen: any, eutIDChosen: any, id: any) {
    // Update the UI Persona Map Model
    pChosen.eutList[eutIDChosen].map =
      pChosen.eutList[eutIDChosen].map == '*' ? '' : '*';

    // Npw update the "actual" Persona Map model
    var mappingExist = this.model.pMap.find(
      (map: any) => map.pType == pChosen.name.pType && map.eID == id
    );
    if (mappingExist) {
      this.delete(pChosen.name.pType, id);
    } else {
      this.add(pChosen.name.pType, id);
    }
  }

  getPersonaForAnEut(eutID: any) {
    var mappedPersonaForEut = this.model.pMap.filter(
      (map: any) => map.eID == eutID
    );
    return mappedPersonaForEut;
  }
  mapEntity(checked: any, persona: any, eutID: any) {
    if (checked.target.checked == true) {
      this.add(persona, eutID);
    } else {
      this.delete(persona, eutID);
    }
  }
  add(persona: any, eutID: any) {
    this.model.pMap.push({ pType: persona, eID: eutID });
  }

  delete(persona: any, eutID: any) {
    var index = this.model.pMap.findIndex(
      (map: any) => map.eID == eutID && map.pType == persona
    );
    if (index > -1) {
      this.model.pMap.splice(index, 1);
    }
  }

  //// model fn closed

  getVideoURL(urlName: any) {
    var videoURL = this.appService.getVideoURL(urlName);
    var element: any = document.getElementById(urlName + 'VideoLink') || {};
    element.src = videoURL;
  }

  terminateVideo() {
    var iframes = document.querySelectorAll('iframe');
    Array.prototype.forEach.call(iframes, iframe => {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: 'stopVideo'
      }), '*');
    });
  }

  loadMappersModel() {
    // this.personaMapperMindmap.model.loadPersonaMap();
    // this.personaMapperMindmap.model.loadPersonaMapUI();
    this.loadPersonaMap(
      this.model.persona,
      this.model.pMap,
      this.model.eutCollection
    );
    this.loadPersonaMapUI(this.model.eutCollection);
  }
}
